<template>
  <section v-if="me" id="section__success" class="view-container">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <v-card class="mt-5 mb-5 py-15">
            <v-card-title class="font--m-2 justify-center">
              본인인증이 완료되었습니다.
              <br />확인버튼을 눌러주세요
            </v-card-title>
          </v-card>
          <BasicButton :to="redirectPath" :disabled="nextLoading" :loading="nextLoading">
            확인
          </BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  data() {
    return {
      nextLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
    redirectPath() {
      return '/kyc/verify-id-card'
    },
  },
  async created() {
    _meta({
      titles: ['본인인증성공'],
    })


    console.log('**** 본인인증 성공 페이지')
    if (await redirectSignupManage()) {
      return
    }

    console.log(' ******** ', this.$route.query.next)

    if( this.$route.query.next ) {
        return this.$router.replace(this.$route.query.next)
    }

    await this.$router.push(this.redirectPath)
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
